// #region Imports

import * as $ from "jquery";

// #endregion Imports

// #region Exports

export function initialize(): void {
    wireHideOnScroll();
}

// #endregion Exports

// #region Private members

let _elements: JQuery<Node>;
let _scrollPosition:number;
let _hidden:boolean;
let _downwards:boolean = false;
let _tracking:boolean = false;
const _distance = 50;   // Hur långt i delta-pixlar innan funktionen ska triggas

// #endregion Private members

// #region Private functions

function wireHideOnScroll(): void {
    _elements = $('.js-hide-on-scroll');

    if (_elements.length === 0) {
        return;
    }

    _hidden = false;
    _scrollPosition = window.pageYOffset;
    $(window).on('scroll', handleScroll);
 
    $('[data-show-hidden-on-scroll]').on( "click", function () {
        const elementIdToShow = $(this).data('show-hidden-on-scroll');
        if(elementIdToShow) {
            const $element = $('#' +elementIdToShow);
            if($element) {
                $element.removeClass($element.data('hidden'));
                if($element.data('body-hidden')) {
                    $('body').removeClass($element.data('body-hidden')); 
                    window.dispatchEvent(new Event("syncHeader", { bubbles: false, cancelable: false }));
                }                
            }
        }
    } );
}

function handleScroll(): void {
    const currentPosition = window.pageYOffset;

    if(currentPosition < 0) {
        _scrollPosition = 0;
        return;
    }

    if(currentPosition > _scrollPosition && !_downwards) {
        _downwards = true;
        _tracking = true;
        _scrollPosition = currentPosition;
    }
    else if(currentPosition < _scrollPosition && _downwards) {
        _downwards = false;
        _tracking = true;
        _scrollPosition = currentPosition;
    }
    else if(!_tracking) {
        _scrollPosition = currentPosition;
    }

    if(!_tracking) {
        return;
    }

    if (_scrollPosition - _distance > currentPosition && _hidden) {
        _hidden = false;
        _elements.each((index, element) => {
            const $element = $(element);
            $element.removeClass($element.data('hidden'));
            if($element.data('body-hidden')) {
                $('body').removeClass($element.data('body-hidden')); 
                window.dispatchEvent(new Event("syncHeader", { bubbles: false, cancelable: false }));
            }            
            
        });
        _tracking = false;
    }
    else if (_scrollPosition + _distance < currentPosition && !_hidden) {
        _hidden = true;
        _elements.each((index, element) => {
            const $element = $(element);
            if (!$element.hasClass('js-locked')) {
                $element.addClass($element.data('hidden')); 
                if($element.data('body-hidden')) {
                    $('body').addClass($element.data('body-hidden')); 
                    window.dispatchEvent(new Event("syncHeader", { bubbles: false, cancelable: false }));
                }
            }
        });
        _tracking = false;
    }
}

// #endregion Private functions